
import { Status } from "../../utility/common/constants/CommonConstants";
import { createDropdown } from "../../utility/common/DropdownComponent/DropdownHelper";
import { todayDate } from "../../utility/common/helpers/TodayDate";

export let PQR_Test = [
  { array: "testerror", Column: "PQR_WP_TypeOfTest", Type: "S" },
  { array: "testerror", Column: "PQR_WP_Acceptance_Criteria", Type: "S" },
  { array: "testerror", Column: "PQR_WP_Result", Type: "S" },
  { array: "testerror", Column: "PQR_WP_Comments", Type: "S" },
  { array: "testerror", Column: "PQR_WP_Report_Nummber", Type: "S" },
];





export const Company_Name = createDropdown("Company Name");




export const division = [{ value: "PED" }];








export let PQRHeader = (wpstype) => {


  return {
    Wld_createdon_year: new Date().getFullYear().toString(),
    wld_WPSType: wpstype,
    CheckboxPostWHT: "",
    PQR_DOB: todayDate,
    PWHT: "Yes",
    Impact: "Yes",
    Hardess: "Yes",
    PQR_RecordNo: "",
    PQR_ReviNo: "",
    PQR_WPS_RecordNo: "",
    PQR_WPS_ReviNo: "",
    PQR_Date: todayDate,
    PQR_CompanyName: "",
    PQR_WeldingStandard: "",
    PQR_Status: "Active",
    wld_createdon: "",
    PQR_Last_UpdatedBy: "",

    PQR_BM_BM_ProductForm: "",
    PQR_BM_BM_Spec: "",
    PQR_BM_BM_Pno: "",
    PQR_BM_BM_Gno: "",
    PQR_BM_BM_Thk: "",
    PQR_BM_BM_Dia: "",
    PQR_BM_BM_Sch: "",
    PQR_BM_BM_Size: "",

    PQR_BM_WTBM_ProductForm: "",
    PQR_BM_WTBM_Spec: "",
    PQR_BM_WTBM_Pno: "",
    PQR_BM_WTBM_Gno: "",
    PQR_BM_WTBM_Thk: "",
    PQR_BM_WTBM_Dia: "",
    PQR_BM_WTBM_Sch: "",
    PQR_BM_WTBM_Size: "",

    // PQR_BM_BM_AndTested: "",
    // PQR_BM_BM_Condition1: "",
    // PQR_BM_BM_Condition2: "",
    PQR_BM_BM_Notes: "",

    PQR_PWHeatTre_Temperature: "",
    PQR_PWHeatTre_Time: "",
    PQR_PWHeatTre_Type: "",
    PQR_PWHeatTre_Heating_Rate: "",
    PQR_PWHeatTre_Heating_Method: "",
    PQR_PWHeatTre_Cooling_Rate: "",
    PQR_PWHeatTre_Cooling_Method: "",
    PQR_PWHeatTre_Notes: "",
    PQR_PWHeatTre_Maintenance: "",

    PQR_JD_JointDesign: "",
    PQR_JD_Backing: "",
    PQR_JD_Retainers: "",
    PQR_JD_GrooveAngle: "",
    // PQR_JD_RootOpening: "",
    // PQR_JD_RootFace: "",
    PQR_JD_Notes: "",

    WPSH_Status: Status.StatusTempSaved,
    WPSH_Approval_Status: Status.StatusTempSaved,

    PQR_DocImage: "",
    PQR_DocImageOriginal: "",

    PQR_DocImageUrl: "",

    PQR_DocImageData: {
      pdfsize: "",
      pdfname: "",
      pdftype: "",
    },
    wld_pdf_image: [],
    Pdf_images: [{ pqr_image1: [""] }, { pqr_image2: [""] }],

    WPSH_PreparedBy_Date: todayDate,
    WPSH_PreparedBy_Name: "",
    WPSH_ApprovedBy_Date: todayDate,
    WPSH_ApprovedBy_Name: "",
    WPSH_ApprovedBy_Remark: "",
    WPSH_PreparedBy_Remark: "",
    WPSH_PreparedBy: sessionStorage.getItem("User"),
    WPSH_UpdatedBy: "",
    WPSH_UpdatedOn: "",
    WPSH_ApprovedBy: sessionStorage.getItem("UserName"),

    PQR_Tensile_RemarksHorizontal: "",
    PQR_GB_RemarksHorizontal: "",
    PQR_TT_RemarksHorizontal: "",
    PQR_HT_RemarksHorizontal: "",
    PQR_OT_RemarksHorizontal: "",

    PQR_Certification_Welder_Name: "",
    PQR_Certification_ID: "",
    PQR_Certification_ConductedBy: "",
    // PQR_Certification_Mechanical_TestsBy: "",
    PQR_Certification_Lab_RefNo: "",

    PQR_SignaturePrepared: "",
    PQR_SignatureApproved: "",

    WPSH_WeldingEnggBy_Date: todayDate,
    WPSH_WeldingEnggBy_Name: "",
    WPSH_WeldingEnggBy: "",
    WPSH_WitnessBy_Date: todayDate,
    WPSH_WitnessBy_Name: "",
    WPSH_WitnessBy: "",
    PQR_WelderId: "",
    WPS_Key: "",
    PQR_WelderName: "",
    WPSH_PQR_Classification: "",
    WPSH_PQR_TradeName: "",
    WPSH_PQR_Process: "",
    WPSH_PQR_Type: "",
  };
};

export let PQR_GroovePage1 = {
  //now commenting non mandatory fields
  PQR_RecordNo: "",
  // PQR_BM_BM_AndTested: "",
  // PQR_BM_BM_Condition1: "",
  // PQR_BM_BM_Condition2: "",
  PQR_BM_BM_Notes: "",

  PQR_JD_JointDesign: "",
  PQR_JD_Backing: "",
  PQR_JD_Retainers: "",
  PQR_JD_GrooveAngle: "",
  PQR_JD_RootOpening: "",
  PQR_JD_RootFace: "",
  PQR_JD_Notes: "",


};

export let PQR_GrooveCheckbox = {
  //now commenting non mandatory fields
  PQR_PWHeatTre_Temperature: "",
  PQR_PWHeatTre_Time: "",
  PQR_PWHeatTre_Type: "",
  PQR_PWHeatTre_Heating_Rate: "",
  PQR_PWHeatTre_Heating_Method: "",
  PQR_PWHeatTre_Cooling_Rate: "",
  PQR_PWHeatTre_Cooling_Method: "",
  PQR_PWHeatTre_Notes: "",
  PQR_PWHeatTre_Maintenance: "",
};

export let PQR_Mandatory_Process = {
  PQR_Process: "",
  PQR_Type: "",
  PQR_Layer: "",
};

export let PQR_Detail_OverlayPage1 = [
  { Column: "PQRD_FM_SFA", Type: "S" },
  { Column: "PQRD_FM_Classification", Type: "S" },
  { Column: "PQRD_FM_FNo", Type: "S" },
  { Column: "PQRD_FM_Ano", Type: "S" },
  { Column: "PQRD_FM_Nominal", Type: "S" },
  { Column: "PQRD_FM_TradeName", Type: "S" },
  { Column: "PQRD_FM_ProductForm", Type: "S" },
  { Column: "PQRD_FM_FillerMetalSize", Type: "A" },
  { Column: "PQRD_FM_DepositedThickness", Type: "S" },
  { Column: "PQRD_FM_MaxPassThickness", Type: "S" },

  { Column: "PQRD_FM_WeldDepositChemistry", Type: "S" },
  { Column: "PQRD_FM_FluxAWS", Type: "S" },
  { Column: "PQRD_FM_FluxType", Type: "S" },
  { Column: "PQRD_FM_FluxNominalComposition", Type: "S" },
  { Column: "PQRD_FM_FluxTradeName", Type: "S" },
  { Column: "PQRD_FM_FluxRecrushed", Type: "S" },
  { Column: "PQRD_FM_Supplement", Type: "S" },
  { Column: "PQRD_FM_FillerMetalOthers", Type: "S" },
  { Column: "PQRD_Position_PositionofGroove", Type: "A" },
  { Column: "PQRD_Position_WeldProgression", Type: "A" },

  { Column: "PQRD_Preheat_MinimumPreheatTemp", Type: "S" },
  { Column: "PQRD_Preheat_MaximumInterpassTemp", Type: "S" },

  { Column: "PQRD_Gas_ShieldingType", Type: "S" },
  { Column: "PQRD_Gas_ShieldingFlowRate", Type: "S" },

  // { Column: "PQRD_Gas_BackingType", Type: "S" },
  // { Column: "PQRD_Gas_BackingFlowRate", Type: "S" },

  // { Column: "PQRD_Gas_TrailingType", Type: "S" },
  // { Column: "PQRD_Gas_TrailingFlowRate", Type: "S" },

  { Column: "PQRD_Electrical_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Electrical_Amperes", Type: "A" },
  { Column: "PQRD_Electrical_Volts", Type: "A" },
  { Column: "PQRD_Electrical_TravelSpeed", Type: "A" },
  { Column: "PQRD_Electrical_MaxHeatInput", Type: "A" },
  { Column: "PQRD_Electrical_TungstenType", Type: "A" },
  { Column: "PQRD_Electrical_CurrentPolarity", Type: "A" },
  { Column: "PQRD_Electrical_DCPulsatingCurrent", Type: "A" },

  { Column: "PQRD_Electrical_WireFeedType", Type: "A" },
  { Column: "PQRD_Electrical_WireFeedSpeed", Type: "A" },

  { Column: "PQRD_Technique_Oscillation", Type: "S" },
  { Column: "PQRD_Technique_ElectrodesSamePuddle", Type: "S" },
  { Column: "PQRD_Technique_Multiple_SingleLayer", Type: "S" },
  { Column: "PQRD_Technique_SupplimentalDevice", Type: "S" },
  { Column: "PQRD_Technique_InitialInterpassCleaning", Type: "S" },
  { Column: "PQRD_Technique_Overlaping", Type: "S" },
  { Column: "PQRD_Technique_CTWD", Type: "S" },



];

export let PQR_Detail_GroovePage1 = [
  { Column: "PQRD_FM_SFA", Type: "S" },
  { Column: "PQRD_FM_Classification", Type: "S" },
  { Column: "PQRD_FM_FNo", Type: "S" },
  { Column: "PQRD_FM_Ano", Type: "S" },
  { Column: "PQRD_FM_Nominal", Type: "S" },
  { Column: "PQRD_FM_TradeName", Type: "S" },
  { Column: "PQRD_FM_ProductForm", Type: "S" },
  { Column: "PQRD_FM_FillerMetalSize", Type: "A" },
  { Column: "PQRD_FM_DepositedThickness", Type: "S" },
  { Column: "PQRD_FM_MaxPassThickness", Type: "S" },
  { Column: "PQRD_FM_FluxAWS", Type: "S" },
  { Column: "PQRD_FM_FluxTradeName", Type: "S" },
  { Column: "PQRD_FM_FluxType", Type: "S" },

  { Column: "PQRD_FM_FluxRecrushed", Type: "S" },
  { Column: "PQRD_FM_Supplement", Type: "S" },
  { Column: "PQRD_FM_FillerMetalOthers", Type: "S" },
  { Column: "PQRD_Position_PositionofGroove", Type: "A" },
  { Column: "PQRD_Position_WeldProgression", Type: "A" },

  { Column: "PQRD_Preheat_MinimumPreheatTemp", Type: "S" },
  { Column: "PQRD_Preheat_MaximumInterpassTemp", Type: "S" },

  { Column: "PQRD_Gas_ShieldingType", Type: "S" },
  { Column: "PQRD_Gas_ShieldingFlowRate", Type: "S" },

  { Column: "PQRD_Gas_BackingType", Type: "S" },
  { Column: "PQRD_Gas_BackingFlowRate", Type: "S" },

  { Column: "PQRD_Gas_TrailingType", Type: "S" },
  { Column: "PQRD_Gas_TrailingFlowRate", Type: "S" },

  { Column: "PQRD_Electrical_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Electrical_Amperes", Type: "A" },
  { Column: "PQRD_Electrical_Volts", Type: "A" },
  { Column: "PQRD_Electrical_TravelSpeed", Type: "A" },
  { Column: "PQRD_Electrical_minBeadLength", Type: "A" },
  { Column: "PQRD_Electrical_ArcTransferMode", Type: "A" },
  { Column: "PQRD_Electrical_MaxHeatInput", Type: "A" },
  { Column: "PQRD_Electrical_TungstenType", Type: "A" },
  { Column: "PQRD_Electrical_CurrentPolarity", Type: "A" },
  { Column: "PQRD_Electrical_DCPulsatingCurrent", Type: "A" },

  { Column: "PQRD_Technique_StringOrWeave", Type: "S" },
  { Column: "PQRD_Technique_Orifice_GasCupSize", Type: "S" },
  { Column: "PQRD_Technique_CTWD", Type: "S" },

  { Column: "PQRD_Technique_Oscillation", Type: "S" },
  { Column: "PQRD_Technique_Multi_SingleElectrode", Type: "S" },
  { Column: "PQRD_Technique_ElectrodeAngle", Type: "S" },
  { Column: "PQRD_Technique_SinglePassPerSide", Type: "S" },
  { Column: "PQRD_Technique_Multiple_SingleLayer", Type: "S" },
  { Column: "PQRD_Technique_Peening", Type: "S" },
  { Column: "PQRD_Technique_InitialInterpassCleaning", Type: "S" },
  { Column: "PQRD_Technique_Technique_Other", Type: "S" },
  { Column: "PQRD_Technique_BackGaugingMethod", Type: "S" },
  { Column: "PQRD_Technique_GroovePreparation", Type: "S" }
];

export let PQR_field_Val = [
  { Column: "PQRD_FM_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Position_PositionofGroove", Type: "A" },
  { Column: "PQRD_Position_WeldProgression", Type: "A" },
  { Column: "PQRD_Electrical_Amperes", Type: "A" },
  { Column: "PQRD_Electrical_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Electrical_Volts", Type: "A" },
  { Column: "PQRD_Electrical_TravelSpeed", Type: "A" },
  { Column: "PQRD_Electrical_ArcTransferMode", Type: "A" },
  { Column: "PQRD_Electrical_minBeadLength", Type: "A" },
  { Column: "PQRD_Electrical_MaxHeatInput", Type: "A" },
  { Column: "PQRD_Electrical_TungstenType", Type: "A" },
  { Column: "PQRD_Electrical_CurrentPolarity", Type: "A" },
  { Column: "PQRD_Electrical_DCPulsatingCurrent", Type: "A" }
];

export let PQR_field_ValOverlay = [
  { Column: "PQRD_FM_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Position_PositionofGroove", Type: "A" },
  { Column: "PQRD_Electrical_Amperes", Type: "A" },
  { Column: "PQRD_Position_WeldProgression", Type: "A" },
  { Column: "PQRD_Electrical_FillerMetalSize", Type: "A" },
  { Column: "PQRD_Electrical_Volts", Type: "A" },
  { Column: "PQRD_Electrical_TravelSpeed", Type: "A" },
  { Column: "PQRD_Electrical_MaxHeatInput", Type: "A" },
  { Column: "PQRD_Electrical_TungstenType", Type: "A" },
  { Column: "PQRD_Electrical_CurrentPolarity", Type: "A" },
  { Column: "PQRD_Electrical_DCPulsatingCurrent", Type: "A" },
  { Column: "PQRD_Electrical_WireFeedType", Type: "A" },
  { Column: "PQRD_Electrical_WireFeedSpeed", Type: "A" },

];


export let PQR_GroovePage2 = {
  PQR_Tensile_RemarksHorizontal: "",
  PQR_GB_RemarksHorizontal: "",
  PQR_TT_RemarksHorizontal: "",
  PQR_Tensile_ReportNumHorizontal: "",
  PQR_GB_ReportNumHorizontal: "",
  PQR_TT_ReportNumHorizontal: "",
  PQR_Certification_ConductedBy: "",
  // PQR_Certification_Mechanical_TestsBy: ""
};

export let PQR_OverlayPage2 = {
  PQR_GB_RemarksHorizontal: "",
  PQR_OT_RemarksHorizontal: "",
  PQR_Certification_ConductedBy: "",
  // PQR_Certification_Mechanical_TestsBy: ""
};

export let PQR_OverlayPage1 = {
  PQR_RecordNo: "",
  PQR_BM_BM_Notes: "",
  PQR_JD_JointDesign: "",
  PQR_JD_Notes: "",
};

export let PQR_OverlayCheckbox = {
  PQR_PWHeatTre_Temperature: "",
  PQR_PWHeatTre_Time: "",
  PQR_PWHeatTre_Type: "",
  PQR_PWHeatTre_Heating_Rate: "",
  PQR_PWHeatTre_Heating_Method: "",
  PQR_PWHeatTre_Cooling_Rate: "",
  PQR_PWHeatTre_Cooling_Method: "",
  PQR_PWHeatTre_Notes: "",
  PQR_PWHeatTre_Maintenance: "",
};

export let PQR_Groove_Detail = [
  { Column: "PQR_Detail_Backing", Type: "S" },
  { Column: "PQR_FM_Specification", Type: "S" },
  { Column: "PQR_FM_Classification", Type: "S" },
  { Column: "PQR_FM_filler_Wire", Type: "S" },
  { Column: "PQR_FM_F_No", Type: "S" },
  { Column: "PQR_FM_Arc_transfermode", Type: "S" },
  { Column: "PQR_FM_Consumable_Insert", Type: "S" },
  { Column: "PQR_FM_Product_Form", Type: "S" },
  { Column: "PQR_FM_No_of_LayerDeposit", Type: "S" },
  { Column: "PQR_FM_Thickness_Limit", Type: "S" },
  { Column: "PQR_FM_Welding_Position", Type: "S" },

  { Column: "PQR_FM_Progression", Type: "S" },
  { Column: "PQR_FM_Current_Polarity", Type: "S" },
  { Column: "PQR_FM_Backing_Gas", Type: "S" },

  { Column: "PQR_FM_Direct_VisualControl", Type: "S" },
  { Column: "PQR_FM_Automatic_jointTracking", Type: "S" },
  { Column: "PQR_FM_Single_Pass_PerSide", Type: "S" },

  { Column: "PQR_FM_Automatic_AVC_System", Type: "S" },
  { Column: "PQR_FM_Notes", Type: "S" },
];

export let PQRHeader_Tube = (wpstype) => {

  return {
    Wld_createdon_year: new Date().getFullYear().toString(),
    wld_WPSType: wpstype,

    WPSH_PQR_Process: "",
    WPSH_PQR_Type: "",
    WPSH_PQR_Classification: "",
    WPSH_PQR_TradeName: "",
    PQR_CompanyName: "",
    CheckboxPostWHT: "",
    pullout_check: "",
    tearCheck: "",
    hardnessCheck: "",
    radioCheck: "",
    otherCheck: "",
    macroCheck: "",

    WPSH_Status: Status.StatusTempSaved,
    WPSH_Approval_Status: Status.StatusTempSaved,

    PQR_RecordNo: "",
    PQR_Date: todayDate,
    PQR_Qualificationcode: "",
    PQR_pWPSNo: "",
    PQR_WPS_ReviNo: "",
    PQR_LastUpdate_Date: todayDate,
    PQR_Last_UpdatedBy: "",
    PQR_Last_WeldDate: todayDate,
    PQR_Address: "",

    PQR_BM_BM_ProductForm: "",
    PQR_BM_BM_Spec: "",
    PQR_BM_BM_Pno: "",
    PQR_BM_BM_Gno: "",
    PQR_BM_BM_Thk: "",
    PQR_BM_BM_Dia: "",
    PQR_FM_PreFillerMetal: "",
    PQR_FM_WithFillerMetal: "",
    PQR_FM_FillerProduct: "",
    PQR_FM_Inserts: "",
    PQR_FM_FillerFlux: "",
    PQR_FM_FillerOthers: "",

    PQR_JD_JointType: wpstype === "Tubesheet" ? "Tube to Tubesheet" : "",
    PQR_JD_TubePitch: "",
    PQR_JD_TubeProj: "",
    PQR_JD_Pattern: "",
    PQR_JD_GrooveAngle: "",
    PQR_JD_RootOpening: "",
    PQR_JD_RootFace: "",
    PQR_JD_Notes: "",


    PQR_PWHeatTre_Temperature: "",
    PQR_PWHeatTre_Time: "",
    PQR_PWHeatTre_Type: "",
    PQR_PWHeatTre_Heating_Rate: "",
    PQR_PWHeatTre_Cooling_Rate: "",
    PQR_PWHeatTre_Notes: "",

    PQRD_WP_SingleMultiElectrode: "",
    PQRD_WP_Peening: "",
    PQRD_WP_ThermalProcess: "",
    PQRD_WP_StringWeave: "",
    PQRD_WP_Oscillation: "",
    PQRD_WP_OrificeCupSize: "",
    PQRD_WP_ClosedOutChamber: "",

    PQR_Certification_Welder_Name: "",
    PQR_Certification_ID: "",
    PQR_Certification_Process: "",
    PQR_Certification_ConductedBy: "",
    // PQR_Certification_Mechanical_TestsBy: "",
    PQR_Certification_Lab_RefNo: "",

    PQR_DocImage: "",
    PQR_DocImageOriginal: "",
    PQR_DocImageUrl: "",
    PQR_DocImageData: {
      pdfsize: "",
      pdfname: "",
      pdftype: "",
    },
    wld_pdf_image: [],

    Pdf_images: [
      { tube_Hole_ligament: [""] },
      { tube_Hole: [""] },
      { tube_Weld_Joint: [""] },
    ],

    PQR_signaturePrepared: "",
    PQR_signatureApproved: "",

    WPSH_PreparedBy_Date: todayDate,
    WPSH_PreparedBy_Name: sessionStorage.getItem("UserName"),
    WPSH_PreparedBy_Remark: "",
    WPSH_PreparedBy: sessionStorage.getItem("User"),
    WPSH_ApprovedBy_Date: todayDate,
    WPSH_ApprovedBy_Name: "",
    WPSH_ApprovedBy_Remark: "",

    WPSH_UpdatedBy: "",
    WPSH_UpdatedOn: "",
    WPSH_ApprovedBy: "",

    WPSH_WeldingEnggBy_Date: todayDate,
    WPSH_WeldingEnggBy_Name: "",
    WPSH_WeldingEnggBy: "",

    WPSH_WitnessBy_Date: todayDate,
    WPSH_WitnessBy_Name: "",
    WPSH_WitnessBy: "",
  };
};
export let PQR_tubePage1 = {
  //now commenting non mandatory fields
  PQR_RecordNo: "",
  PQR_Qualificationcode: "",
  PQR_LastUpdate_Date: "",
  PQR_Last_UpdatedBy: "",
  PQR_Last_WeldDate: "",
  // PQR_Address: "",


  PQR_JD_JointType: "",
  PQR_JD_TubePitch: "",
  PQR_JD_TubeProj: "",
  PQR_JD_Pattern: "",
  PQR_JD_GrooveAngle: "",
  PQR_JD_Notes: "",


  PQR_Image_Notes: "",
  // PQR_Certification_Welder_Name: "",
  // PQR_Certification_ID: "",
  // PQR_Certification_ConductedBy: "",
  // PQR_Certification_Mechanical_TestsBy: "",
  // PQR_Certification_Lab_RefNo: "",

  PQR_PWHeatTre_Temperature: "",
  PQR_PWHeatTre_Time: "",
  PQR_PWHeatTre_Type: "",
  // PQR_PWHeatTre_Heating_Rate: "",
  PQR_PWHeatTre_Cooling_Rate: "",
  PQR_PWHeatTre_Notes: "",
};

export let PQR_tubesheet_pg1_array = [
  { Column: "PQRD_WP_LayerNo", Type: "S" },
  { Column: "PQRD_WP_FillerMetalSize", Type: "S" },
  { Column: "PQRD_WP_Amperes", Type: "S" },
  { Column: "PQRD_WP_DC_Pulsing_current", Type: "S" },
  { Column: "PQRD_WP_DC_Pulsing_current_Others", Type: "S" },
  { Column: "PQRD_WP_Volatage_Volts", Type: "S" },
  { Column: "PQRD_WP_Travel_Speed", Type: "S" },
  { Column: "PQRD_WP_Heat_Input", Type: "S" },
  { Column: "PQRD_WP_PolarityOrCurrent", Type: "S" },
];

export let PQR_Tube_Page1_Process = {
  WPSD_Process: "GTAW",
  WPSD_FM_SFA: ""  
};

export let PQR_Detail_TubePage1 = [
   { Column: "PQRD_WP_MinimumPreheatTemp", Type: "S" },
   { Column: "PQRD_WP_MaximumInterpassTemp", Type: "S" },
   { Column: "PQRD_WP_PostHeating", Type: "S" },
   { Column: "PQRD_WP_TungstenType", Type: "S" },
   { Column: "PQRD_WP_WeldPosition", Type: "S" },
   { Column: "PQRD_WP_WeldProgression", Type: "S" },
  { Column: "PQRD_WP_NoofPasses", Type: "S" },
   { Column: "PQRD_WP_ShieldingGasType", Type: "S" },
   { Column: "PQRD_WP_ShieldingFlowRate", Type: "S" },
   { Column: "PQRD_WP_Auxiliarygas", Type: "S" },
   { Column: "PQRD_WP_Expansion", Type: "S" },
   { Column: "PQRD_WP_MethodofCleaning", Type: "S" },
   { Column: "PQRD_WP_SingleMultiElectrode", Type: "S" },
   { Column: "PQRD_WP_Peening", Type: "S" },
   { Column: "PQRD_WP_ThermalProcess", Type: "S" },
   { Column: "PQRD_WP_StringWeave", Type: "S" },
   { Column: "PQRD_WP_Oscillation", Type: "S" },
   { Column: "PQRD_WP_OrificeCupSize", Type: "S" },
   { Column: "PQRD_WP_ClosedOutChamber", Type: "S" },
   ]

export let PQR_tubesheet_page1_2input = [
  { Column: "PQRD_WP_LayerNo", Type: "S" },
  { Column: "PQRD_WP_FillerMetalSize", Type: "S" },
  { Column: "PQRD_WP_Amperes", Type: "S" },
  { Column: "PQRD_WP_DC_Pulsing_current", Type: "S" },
  { Column: "PQRD_WP_DC_Pulsing_current_Others", Type: "S" },
  { Column: "PQRD_WP_Volatage_Volts", Type: "S" },
  { Column: "PQRD_WP_Travel_Speed", Type: "S" },
  { Column: "PQRD_WP_Heat_Input", Type: "S" },
  { Column: "PQRD_WP_PolarityOrCurrent", Type: "S" },
];

export let PQR_tubePage2 = {
  PQR_VEX_Notes: "",
  PQR_VEX_ReportNumHorizontal: "",
  PQR_LPEX_Notes: "",
  PQR_LPEX_ReportNumHorizontal: "",
  PQR_MEX_Result: "",
  PQR_MLP_Result: "",
  PQR_MLP_ReportNumHorizontal: "",
};

export let PQR_tubePage2array = {
  Visual_Examination: "",
};


export let PQR_tubePage3 = {
  PQR_Tear_Notes: "",
  PQR_PullOut_Notes: "",  
  PQR_PullOut_MinBreakLoad: "",
  PQR_PullOut_AreaTubeMaterial: "",
  PQR_PullOut_MinTensilStrength: "",
  PQR_PullOut_MinBreakStress: "",
  PQR_PullOut_FrValue: "",
  PQR_HT_Notes: "",
  PQR_HT_ReportNumHorizontal: "",
  PQR_PullOut_AccCriteria_Notes: "",
  PQR_PullOut_ReportNumHorizontal: "",
  PQR_Radio_Notes: "",
  PQR_Radio_ReportNumHorizontal: "",
  PQR_OT_Notes: "",
};

export let pqrJointType = [
  { value: "Tube to Tubesheet", name: "PQR_JD_JointType" },
];




